<template>
  <slider-topics />

  <the-nav />

  <div class="main-wrap">
    <div id="themeslots">
      <div class="themeslots-1">
        <template v-for="topic in topics" :key="topic.slug + '-' + isAuthenticated">
          <topic-slider v-bind="topic" />
        </template>
      </div>
    </div>

    <bonuses-line />

    <play-line />
  </div>
</template>

<script>
import SliderTopics from '@/components/sliders/SliderTopics.vue'
import PlayLine from '@/components/PlayLine'
import BonusesLine from '@/components/BonusesLine.vue'
import TheNav from '@/components/TheNav'
import { mapGetters } from 'vuex'
import TopicSlider from '@/components/topics/TopicSlider.vue'

export default {
  name: 'Topics',
  components: { SliderTopics, TopicSlider, PlayLine, BonusesLine, TheNav },
  computed: {
    ...mapGetters(['topics', 'isAuthenticated']),
  },
  data() {
    return {
      show: false,
    }
  },
}
</script>

<style scoped></style>
